import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FormService {
  constructor(private http: HttpClient) {}

  submitFormData(formData: any) {
    const lambdaUrl = environment.contactFormUrl;
    return this.http.post(lambdaUrl, formData, environment.HTTP_OPTIONS);
  }
}
